import { loadEntities } from 'core/loadEntities';
import { loadControllers } from 'core/loadControllers';
import { loadWorld } from 'core/loadWorld';
import { loadRenderers } from 'core/loadRenderers';
import { loadCameras } from 'core/loadCameras';
import { loadSystems } from 'core/loadSystems';
import { loadVariables } from 'core/loadVariables';

function start() {

  let sound = this.assets.sounds.demo.backtrack();
  sound.currentTime=0
  sound.play()
  sound.loop=true;
  
  this.logger.log(`start ${this.currentScene} scene`);

  this.$controllers = loadControllers.call(this);

  this.$variables = loadVariables.call(this);
  this.$world = loadWorld.call(this);
  this.$cameras = loadCameras.call(this);
  this.$renderers = loadRenderers.call(this);
  this.$systems = loadSystems.call(this);
  const entities = loadEntities.call(this);
  this.$world.add(entities);
}

export { start };
